import React from 'react';

import styles from './Footer.module.scss';

export const Footer = () => (
  <div className={styles.footer}>
    <span>Copyright © 2022–{new Date().getFullYear()}</span>
    <a
      className={styles.link}
      href="https://www.calvin-risk.com/"
      target="_blank"
      rel="noreferrer"
    >
      Calvin Risk AG
    </a>
  </div>
);
